import { message, Select } from "antd";
import { FC, useEffect, useState } from "react";
import restful from "../../restful"

const SelectCategoriesField: FC<any> = (props: any) => {
  const [options, setOptions] = useState<any>()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    restful.get('/categories/options', {})
      .then((res) => {
        const opts = []
        for (const item of res.data.result.options) {
          opts.push({ label:  item.title, value: item._id })
        }
        setOptions(opts)
      })
      .catch((err) => message.error(err.message))
      .finally(() => setLoading(false));;
  }, [])

  return (
    <Select
      {...props}
      loading={loading}
      options={options}
      allowClear
      showSearch
      optionFilterProp="label" />

  )
}

export default SelectCategoriesField
